import { useAlternateLinks, useHead as useHeadBase, useRoute } from '#imports'
import { type Ref, computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useAddCanonicalLink } from '~/scopes/seo/composables/useAddCanonicalLink'

import translations from './useHead.translations'

export function useHead(
  productModel: Ref<string | undefined>,
  metaDescription: Ref<string>,
  {
    dateMonthLongCapitalized,
    dateYearNumeric,
  }: { dateMonthLongCapitalized: string; dateYearNumeric: string },
) {
  const { getAlternateLinks } = useAlternateLinks()
  const i18n = useI18n()
  const route = useRoute()

  const metaTitle = computed(() =>
    i18n(translations.metaTitle, {
      dateMonthLongCapitalized,
      dateYearNumeric,
      productModel: productModel.value,
    }),
  )

  useHeadBase({
    title: metaTitle.value,
    meta: [
      {
        property: 'og:title',
        hid: 'og:title',
        content: metaTitle.value,
      },
      {
        name: 'description',
        hid: 'description',
        content: metaDescription.value,
      },
      {
        property: 'og:description',
        hid: 'og:description',
        content: metaDescription.value,
      },
    ],
    link: getAlternateLinks({ link: route.path }),
  })
  useAddCanonicalLink()
}
